import {Component, Inject} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import {TranslateService} from '@ngx-translate/core';

@Component({
   selector: 'app-confirm-dialog-create-task',
   templateUrl: './confirm-dialog-create-task.component.html',
   styleUrls: ['./confirm-dialog-create-task.component.css']
})
export class ConfirmDialogCreateTaskComponent {

   constructor(private _formBuilder: FormBuilder, private dialogRef: MatDialogRef<ConfirmDialogCreateTaskComponent>,
               private translate: TranslateService, @Inject(MAT_DIALOG_DATA) public data: any) {
   }

   onClickConfirm() {
      this.data.create_task.disableBtn(this.data.btnBack, this.data.btnCancel, this.data.btnSave, this.data.btnSend, true);
      if (this.data.mode !== 'edit') {
         for (let i = 0; i < this.data.taskAttribute.docList.length; i++) {

            const docId = this.data.taskAttribute.docList[i].docId;
            if (this.data.data.item !== undefined && this.data.data.item.id !== docId) {
               this.data.data.service.deleteDocument(docId)
                  .subscribe(() => {
                     // This is intentional
                  });
            } else if (this.data.data.item === undefined) {
               this.data.service.deleteDocument(docId)
                  .subscribe(() => {
                     // This is intentional.
                  });
            }
         }
      } else {
         for (let i = 0; i < this.data.uploadComp.docNew.length; i++) {
            this.data.service.deleteDocument(this.data.uploadComp.docNew[i])
               .subscribe(() => {
                  // This is intentional.
               });
         }
      }
      this.data.create_task.disableBtn(this.data.btnBack, this.data.btnCancel, this.data.btnSave, this.data.btnSend, false);
      this.data.create_task.closePage();
      this.dialogRef.close(true);
   }


}
